import FileUploader from 'Shared/components/ImageUploader/FileUploader'
import './AudioSetting.scoped.scss'

export default function AudioSetting({ 
  label, 
  value, 
  onUploaded, 
  helpText,
  allowedTypes,
  fileTypeError
}) {
  const [error, setError] = useState(null)

  const handleUploaded = (val) => {
    setError(null)
    onUploaded(val)
  }

  const handleError = (errorMessage) => {
    setError(errorMessage)
  }

  return (
    <div className="field audio-field margin-top half">
      <label>{label}</label>
      <div className="flex-center gap-10">
        <div>
          <FileUploader 
            onUploaded={handleUploaded}
            allowedTypes={allowedTypes}
            fileTypeError={fileTypeError}
            onError={handleError}
          />
        </div>
        <div>
          {value && (
            <audio controls>
              <source src={`/rails/active_storage/blobs/${value}/audio`} />
              Your browser does not support the audio element.
            </audio>
          )}
        </div>
      </div>
      {error && (
        <p className="error margin-top half">{error}</p>
      )}
      <p className="help margin-top half">{helpText}</p>
    </div>
  )
}
